// Enum representing the type of shipment
export enum ShipmentType {
    Parcel = 'Parcel',
    Letter = 'Letter',
}
